import { combineReducers, Reducer } from 'redux'
import {
  ICarrierState,
  ICarrierContactState,
  ICarrierFMCSAState,
  ICarrierAccountingState,
  ICommodityState,
  ICarrierReferencesState,
  ICarrierVinState,
  ICompanyInfoState,
  ILaneHistoryState,
  ICarrierCapacityState,
  ICarrierLanesState,
  ICarrierEquipmentState,
  ICarrierDocumentsCheckListsState,
} from 'types/carrier'
import { IGlobalMessagingState } from 'types/globalMessaging'
import { ILogsState } from 'types/logs'
import { IShipmentsCountState, IShipmentsState } from 'types/shipment'
import { IUsersState } from 'types/user'
import carrierMetaReducer from 'utils/reducers/carrier'
import carrierDocumentsCheckListsReducer from 'utils/reducers/carrierDocumentsChecklists'
import carrierDocumentsUploadsReducer from 'utils/reducers/carrierDocumentsUploads'
import carrierInsuranceReducer from 'utils/reducers/carrierInsurance'
import fmcsaMetaReducer from 'utils/reducers/fmcsa'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import logsReducer from 'utils/reducers/logs'
import notesReducer from 'utils/reducers/notes'
import shipmentsReducer from 'utils/reducers/shipments'
import shipmentsCountReducer from 'utils/reducers/shipmentsCount'
import tagsReducer from 'utils/reducers/tags'
import usersReducer from 'utils/reducers/users'
import carrierCapacityReducer from './capacity'
import accountingReducer from './carrierAccounting'
import carrierCommoditiesReducer from './carrierCommodities'
import carrierContactReducer from './carrierContact'
import carrierInsuranceDialogReducer from './carrierInsuranceDialog'
import carrierLanesReducer from './carrierLanes'
import carrierReferencesReducer from './carrierReferences'
import carrierVinsReducer from './carrierVins'
import companyInfoReducer from './companyInfo'
import equipmentReducer from './equipment'
import laneHistoryReducer from './laneHistory'
import uiReducer, { IUiReducerState } from './ui'

export interface IStore {
  carrier: ICarrierState
  carrierFMCSA: ICarrierFMCSAState
  carrierEquipment: ICarrierEquipmentState
  carrierVins: ICarrierVinState
  accounting: ICarrierAccountingState
  ui: IUiReducerState
  carrierInsurance: {}
  carrierInsuranceDialog: {}
  carrierDocumentsCheckLists: ICarrierDocumentsCheckListsState
  carrierDocumentsUploads: {}
  shipments: IShipmentsState
  shipmentsCount: IShipmentsCountState
  carrierCommodities: ICommodityState
  carrierReferences: ICarrierReferencesState
  companyInfo: ICompanyInfoState
  carrierContact: ICarrierContactState
  carrierCapacity: ICarrierCapacityState
  globalMessaging: IGlobalMessagingState
  notes: {}
  tags: {}
  users: IUsersState
  logs: ILogsState
  laneHistory: ILaneHistoryState
  carrierLanes: ICarrierLanesState
}

const reducers = combineReducers<IStore>({
  carrier: carrierMetaReducer as Reducer<ICarrierState>,
  carrierFMCSA: fmcsaMetaReducer,
  carrierEquipment: equipmentReducer,
  carrierVins: carrierVinsReducer,
  accounting: accountingReducer,
  ui: uiReducer as Reducer<IUiReducerState>,
  carrierInsurance: carrierInsuranceReducer as Reducer<{}>,
  carrierInsuranceDialog: carrierInsuranceDialogReducer as Reducer<{}>,
  carrierDocumentsCheckLists: carrierDocumentsCheckListsReducer as Reducer<
    ICarrierDocumentsCheckListsState
  >,
  carrierDocumentsUploads: carrierDocumentsUploadsReducer as Reducer<{}>,
  shipments: shipmentsReducer as Reducer<IShipmentsState>,
  shipmentsCount: shipmentsCountReducer as Reducer<IShipmentsCountState>,
  carrierCommodities: carrierCommoditiesReducer,
  carrierReferences: carrierReferencesReducer,
  companyInfo: companyInfoReducer,
  carrierContact: carrierContactReducer,
  carrierCapacity: carrierCapacityReducer,
  globalMessaging: globalMessagingReducer,
  notes: notesReducer as Reducer<{}>,
  tags: tagsReducer as Reducer<{}>,
  users: usersReducer,
  logs: logsReducer,
  laneHistory: laneHistoryReducer,
  carrierLanes: carrierLanesReducer,
})

export default reducers
